export var SeverityLevel;
(function (SeverityLevel) {
    SeverityLevel["critical"] = "critical";
    SeverityLevel["important"] = "important";
    SeverityLevel["success"] = "success";
    SeverityLevel["information"] = "information";
})(SeverityLevel || (SeverityLevel = {}));
//# sourceMappingURL=notificationService.js.map